import { render, staticRenderFns } from "./tag-or-untag-customer-summary.vue?vue&type=template&id=1cf6975c&"
import script from "./tag-or-untag-customer-summary.vue?vue&type=script&lang=js&"
export * from "./tag-or-untag-customer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports